"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MobileNav =
/*#__PURE__*/
function (_Component) {
  _inherits(MobileNav, _Component);

  function MobileNav(props) {
    var _this;

    _classCallCheck(this, MobileNav);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MobileNav).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleSubMenu", function (event) {
      var nodeItem = event.target.parentNode;
      var subItems = null;
      var icon = null;
      console.log(event.target.parentNode);

      if (nodeItem.classList.contains("nav-mobile-title")) {
        subItems = nodeItem.nextSibling;
        icon = nodeItem.childNodes[1];
      } else if (nodeItem.classList.contains("nav-mobile-column")) {
        subItems = nodeItem.childNodes[1];
        icon = nodeItem.firstChild.childNodes[1];
      }

      if (subItems !== null) {
        subItems.classList.contains("hidden") ? subItems.classList.remove("hidden") : subItems.classList.add("hidden");
      }

      if (icon !== null) {
        if (icon.classList.contains("fa-chevron-up")) {
          icon.classList.remove("fa-chevron-up");
          icon.classList.add("fa-chevron-down");
        } else if (icon.classList.contains("fa-chevron-down")) {
          icon.classList.remove("fa-chevron-down");
          icon.classList.add("fa-chevron-up");
        }
      }

      event.stopPropagation();
    });

    _this.state = {
      showNav: false
    };
    return _this;
  }

  _createClass(MobileNav, [{
    key: "toggleMobileNav",
    value: function toggleMobileNav() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.setState({
        showNav: !this.state.showNav
      });
    }
  }, {
    key: "getNavClass",
    value: function getNavClass() {
      return this.state.showNav ? "has-sub sub-active close-nav-btn" : "has-sub news";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("nav", {
        className: "footer-nav mobile-display-gray"
      }, _react.default.createElement("ul", null, _react.default.createElement("li", {
        className: this.getNavClass(),
        onClick: function onClick() {
          return _this2.toggleMobileNav();
        }
      }, _react.default.createElement("ul", {
        className: "submenu submenu-small"
      }, _react.default.createElement("li", {
        className: "nav-column-row"
      }, this.props.headerData.map(function (item, index) {
        if (item.link === "#") {
          return _react.default.createElement("div", {
            className: "nav-mobile-column",
            key: "item-".concat(index)
          }, _react.default.createElement("div", {
            className: "nav-mobile-title",
            onClick: function onClick(event) {
              return _this2.toggleSubMenu(event);
            }
          }, _react.default.createElement("span", null, item.label), _react.default.createElement("i", {
            className: "fa fa-chevron-up",
            "aria-hidden": "true"
          })), _react.default.createElement("ul", {
            className: "sub-nav-items"
          }, item.subNavItems.map(function (subItem, index) {
            return _react.default.createElement("li", {
              key: "subItem-".concat(index)
            }, _react.default.createElement(_reactRouterDom.Link, {
              to: subItem.link
            }, subItem.label));
          })));
        } else {
          return _react.default.createElement("div", {
            className: "nav-mobile-column",
            key: "item-".concat(index)
          }, _react.default.createElement("div", {
            className: "nav-mobile-title"
          }, _react.default.createElement(_reactRouterDom.Link, {
            to: item.link
          }, item.label)));
        }
      }))))));
    }
  }]);

  return MobileNav;
}(_react.Component);

var _default = MobileNav;
exports.default = _default;